import {ObservationsFilter} from "@/models/Enums";

export default class ObservationsFiltersData {
    items: ObservationsFilter[] = [];
}